import { FilterValue } from "../Filters/FilterValue";
import { ModuleTasks } from "../ModuleType";
import { OrderMockup } from "../Order/OrderMockup";
import { OrderProduct } from "../Order/OrderProduct";
import { VendorInvoice } from "./InventoryOpsRequests";
import { PurchaseOrder } from "./PurchaseOrder";

export interface ProjectInventoryOpsProduct {
  purchase_orders: PurchaseOrder[];
  print_inward_timelines: PrintInward[];
  order_id?: number;
  id: number;
  name: string;
  quantity: number;
  customisation_required?: boolean;
  used_quantity: number;
  sku?: string;
  image_url?: string;
  image_urls?: string[];
  mockups?: OrderMockup[];
  category_id?: number;
  category_name?: string;
  active?: boolean;
  cost_price: number;
  unit_price: number;
  hsn_code?: string;
  gst_percentage?: number;

  raw_inward_qty?: number;
  raw_inward_qc_rejection_qty?: number;
  print_outward_qty?: number;
  print_inward_qty?: number;
  print_inward_qc_rejection_qty?: number;

  completed_tasks?: {
    raw_inward: boolean;
    raw_inward_qc: boolean;
    print_outward: boolean;
    print_inward: boolean;
    print_inward_qc: boolean;
  };

  completed_task_count?: number;
}

export interface InventoryOpsDetails {
  brand_name: string;
  raw_inward: RawInward[];
  raw_inward_qc: RawInwardQc[];
  print_outward: PrintOutward[];
  print_inward: PrintInward[];
  print_inward_qc: PrintInwardQc[];
}

export interface RawInward {
  id: number;
  po_id: number;
  product_id: number;
  quantity_received: number;
  total_received_quantity: number;
}

export interface RawInwardQc {
  product_id: number;
  rejected_quantity: number;
  rejection_reason: string;
  total_rejected_quantity: number;
}

export interface PrintOutward {
  modified_date: Date;
  printer_id: number;
  product_id: number;
  quantity_sent: number;
  raw_inward_id: number;
  storage_id: number;
  timeline: Date;
  total_quantity_sent: number;
}

export interface PrintInward {
  active?: number;
  admin_id?: number;
  created_date?: Date;
  id?: number;
  modified_date?: Date;
  print_outward_id?: number;
  product_id?: number;
  quantity_received?: number;
  total_received_quantity?: number;
  raw_inward_id?: number;
  po_id?: number;

  timeline?: string;
  expected_delivery_date?: string;
}

export interface PrintInwardQc {
  active: number;
  admin_id: number;
  created_date: Date;
  id: number;
  modified_date: Date;
  print_inward_id: number;
  product_id: number;
  rejected_quantity: number;
  rejection_reason: string;
  total_rejected_quantity: number;
}

export interface InventoryListingDetails {
  module_tasks: ModuleTasks[];
  brand_name: string;
  label: string;
  products: ProjectInventoryOpsProduct[];
  raw_inward_qc_percentage: number;
  print_inward_qc_percentage: number;
  total_progress: number;
  archived?: number;
}

export interface InventoryOpsPoDetail {
  po_id: number;
  warehouse_id?: string | null;
  warehouse_identifier?: string | null;
  raw_inward_id?: number | null;
  raw_inward_quantity?: number | null;
  raw_inward_rejection_quantity?: number | null;
  raw_inward_rejection_reason?: string | null;
  print_inward_due_date?: string;
  print_outward_id?: number;
  print_outward_printer_id?: number;
  storage_id?: number;
  print_outward_printer_name?: string;
  print_outward_quantity?: number;
  print_outward_timeline?: Date;
  print_inward_id?: number | null;
  print_inward_quantity?: number | null;
  print_inward_rejection_quantity?: number | null;
  print_inward_rejection_reason?: string | null;
  product_po_quantity?: number;
  vendor_name?: string;
  raw_inward_qc_images?: QcImages[] | null;
  print_inward_qc_images?: QcImages[] | null;

  temp_raw_inward_quantity?: number | null;
  temp_raw_inward_rejection_quantity?: number | null;
  temp_raw_inward_rejection_reason?: string | null;
  temp_print_inward_due_date?: string | null;
  temp_print_outward_id?: number | null;
  temp_print_outward_printer_id?: number | null;
  temp_storage_id?: number | null;
  temp_print_outward_printer_name?: string | null;
  temp_print_outward_quantity?: number | null;
  temp_print_outward_timeline?: Date | null;
  temp_print_inward_id?: number | null | null;
  temp_print_inward_quantity?: number | null;
  temp_print_inward_rejection_quantity?: number | null;
  temp_print_inward_rejection_reason?: string | null;
  temp_raw_inward_qc_images?: File[] | null;
  temp_print_inward_qc_images?: File[] | null;

  raw_inward_mark_received?: boolean;
  print_inward_mark_received?: boolean;

  raw_inward_qc_start?: boolean;
  print_inward_qc_start?: boolean;

  raw_inward_qc_on_hold?: boolean;
  raw_inward_qc_reason_for_hold?: string;

  print_inward_qc_on_hold?: boolean;
  print_inward_qc_reason_for_hold?: string;

  temp_raw_inward_qc_hold_reason?: string;
  temp_print_inward_qc_reason_for_hold?: string;

  raw_inward_in_progress?: boolean;
  print_inward_in_progress?: boolean;
}

export interface VendorInvoiceDetails {
  invoice_received?: boolean;
  invoice_received_updated_at?: Date;
  invoice_received_updated_by?: number;
  invoice_received_updated_by_name?: string;

  invoices?: VendorInvoice[];
}

export interface ProjectInventoryOpsProductDetails {
  product: OrderProduct;
  purchase_orders: PurchaseOrder[];
  mockups: OrderMockup[];
  size_mixes: any[];
  progress: number;
  inventory_ops_details: InventoryOpsPoDetail[];
}

export interface ProjectInventoryOpsSummary {
  po_id: number;
  raw_inward_id: number;
  history: {
    [date: string]: SummaryHistory[];
  };
}

export interface QcImages {
  id: number;
  admin_id: number;
  image_url: string;
  print_inward_id: number;
}
export interface SummaryHistory {
  po_id: number | null;
  type: string;
  id: number;
  printer_id?: number;
  print_inward_id?: number;
  raw_inward_id?: number;
  print_outward_id?: number;
  quantity_received?: number;
  total_received_quantity?: number;
  mark_received?: number;
  quantity_sent?: number;
  total_quantity_sent?: number;
  storage_id?: number;
  rejection_reason?: string | null;
  rejected_quantity?: number;
  total_rejected_quantity?: number;
  order_id?: number;
  product_id?: number;
  admin_id: number;
  active: number;
  created_date: string;
  modified_date: string;
  start_time?: string;
  end_time?: string | null;
  cumulative_time?: number;
  timeline?: string;
  admin_name: string;
  printer_name?: string;
  image_url?: string;
}

export enum InvoicePaymentStatus {
  PAID = 1,
  PARTIAL = 2,
  PENDING = 3,
}

export const InvoicePaymentStatusFilters: FilterValue[] = [
  { id: "paid", value: "Paid" },
  { id: "partial_paid", value: "Partial" },
  { id: "pending", value: "Pending" },
];
